import { EXPECTED_SUBDOMAIN } from '@backoffice-frontend/common'
import { Environment } from '@backoffice-frontend/environment'
import store from 'store'

export const backofficeBaseDomains: Partial<Record<Environment, string>> = {
  [Environment.development]: '.backoffice.dev.moia-group.io',
  [Environment.integration]: '.backoffice.int.moia-group.io',
  [Environment.production]: '.backoffice.moia-group.io',
  [Environment['production.us-east-1']]: '.backoffice.us.moia-group.io',
}

export const getSubdomainFromHostname = (hostname: string): string | null => {
  const [subdomain] = hostname.split('.')

  if (!subdomain || subdomain === hostname) {
    return null
  }

  return subdomain
}

type UrlLocation = Pick<Location, 'pathname' | 'search' | 'hash'>

export const buildBackofficeUrl = (
  subdomain: string,
  baseDomain: string,
  location: UrlLocation,
): string =>
  `https://${subdomain}${baseDomain}${location.pathname}${location.search}${location.hash}`

type CachedSubdomain = { email: string; subdomain: string }

/**
 * The subdomain a user belongs on only changes when their account moves, so it
 * is cached to keep the lookup off the critical path. Storage is per origin, so
 * the cache is always cold on a subdomain the user has not used before — which
 * is exactly the case the check needs to catch.
 */
export const readCachedSubdomain = (email: string): string | null => {
  const cached = store.get(EXPECTED_SUBDOMAIN) as CachedSubdomain | undefined

  return cached?.email === email ? cached.subdomain : null
}

export const writeCachedSubdomain = (email: string, subdomain: string): void =>
  store.set(EXPECTED_SUBDOMAIN, { email, subdomain })
